// @mui

import { GetVisitById } from 'woofwoof-api';
import OrganizationVisitModalDetailsTabs from './OrganizationVisitModalDetailsTabs';

// ---------------------------------------------------------------------

type OrganizationVisitModalDetailsTabProps = {
  visit?: GetVisitById;
  onVisitDataChange?: () => void;
};

export default function OrganizationVisitModalDetailsTab({
  visit,
  onVisitDataChange,
}: OrganizationVisitModalDetailsTabProps) {
  if (!visit) {
    return null;
  }

  return (
    <OrganizationVisitModalDetailsTabs
      visit={visit}
      onVisitDataChange={onVisitDataChange}
    />
  );
}
